module.exports = __webpack_public_path__ + "static/img/giphy_grapefruitmargarita.468a33f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/giphy_grapefruitmargarita.gif
// module id = wy5J
// module chunks = 0